import { createContext } from "react";

import type { ContextualMenuItem } from "./types";

export type ContextualMenuLayer = {
    label: string;
    items: ContextualMenuItem[];
};

export const ContextualMenuStackContext = createContext<ContextualMenuLayer[]>([]);
